// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.folder-tree {
  border: 1px solid var(--border-light);
  border-radius: 8px;
  background: #fff;
  max-height: 280px;
  overflow-y: auto;
  padding: 4px 0;
  font-size: 13px;
  outline: none;
}

.folder-tree--empty {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  padding: 16px;
  color: var(--text-muted, #8a8a8a);
  font-size: 12px;
}

.folder-tree--empty .material-icons-round {
  font-size: 16px;
}

.folder-tree-row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 8px;
  cursor: pointer;
  user-select: none;
  outline: none;
  border-radius: 4px;
  margin: 1px 4px;
}

.folder-tree-row:hover {
  background: var(--hover-bg, rgba(0, 0, 0, 0.04));
}

.folder-tree-row:focus-visible {
  box-shadow: 0 0 0 2px var(--primary);
}

.folder-tree-row.is-selected {
  background: var(--primary-soft, rgba(0, 120, 212, 0.12));
  color: var(--primary);
  font-weight: 500;
}

.folder-tree-row--root {
  font-weight: 500;
  border-bottom: 1px solid var(--border-light);
  border-radius: 0;
  margin: 0;
  padding-top: 6px;
  padding-bottom: 6px;
}

.folder-tree-row--pending {
  cursor: default;
}

.folder-tree-row--pending:hover {
  background: transparent;
}

.folder-tree-pending-input {
  flex: 1;
  border: 1px solid var(--primary, #0078d4);
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 13px;
  outline: none;
  min-width: 0;
}

.folder-tree-pending-input:disabled {
  opacity: 0.6;
}

.folder-tree-pending-error {
  color: var(--error, #c4314b);
  font-size: 11px;
  padding: 2px 8px 4px;
}

.folder-tree-rename-wrap {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.folder-tree-rename-wrap .folder-tree-pending-error {
  padding: 0;
}

.folder-context-menu {
  position: fixed;
  z-index: 1000;
  background: #fff;
  border: 1px solid var(--border-light);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  min-width: 160px;
}

.folder-context-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px 12px;
  background: transparent;
  border: none;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  color: inherit;
}

.folder-context-menu-item:hover:not(:disabled) {
  background: var(--hover-bg, rgba(0, 0, 0, 0.05));
}

.folder-context-menu-item:disabled {
  opacity: 0.45;
  cursor: default;
}

.folder-context-menu-item .material-icons-round {
  font-size: 16px;
  color: var(--primary, #0078d4);
}

.folder-context-menu-item--danger {
  color: var(--error, #c4314b);
}

.folder-context-menu-item--danger .material-icons-round {
  color: var(--error, #c4314b);
}

.folder-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 16px;
}

.folder-confirm-dialog {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 16px;
  max-width: 360px;
  width: 100%;
  font-size: 13px;
}

.folder-confirm-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

.folder-confirm-icon {
  font-size: 20px;
  color: var(--error, #c4314b);
}

.folder-confirm-body {
  margin: 0 0 12px;
  line-height: 1.4;
  color: var(--text, #2d2d2d);
}

.folder-confirm-error {
  margin: 0 0 12px;
  color: var(--error, #c4314b);
  font-size: 12px;
}

.folder-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.folder-confirm-btn {
  padding: 6px 14px;
  border-radius: 4px;
  border: 1px solid var(--border-light);
  background: #fff;
  font-size: 13px;
  cursor: pointer;
  color: inherit;
}

.folder-confirm-btn:hover:not(:disabled) {
  background: var(--hover-bg, rgba(0, 0, 0, 0.05));
}

.folder-confirm-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.folder-confirm-btn--danger {
  background: var(--error, #c4314b);
  border-color: var(--error, #c4314b);
  color: #fff;
}

.folder-confirm-btn--danger:hover:not(:disabled) {
  background: #a8273c;
}

.folder-confirm-btn--primary {
  background: var(--primary, #0078d4);
  border-color: var(--primary, #0078d4);
  color: #fff;
}

.folder-confirm-btn--primary:hover:not(:disabled) {
  opacity: 0.9;
}

.folder-move-dialog {
  max-width: 420px;
}

.folder-move-icon {
  font-size: 20px;
  color: var(--primary, #0078d4);
}

.folder-move-tree-wrap {
  margin: 0 0 10px;
}

.folder-move-tree-wrap .folder-tree {
  max-height: 220px;
}

.folder-move-summary {
  margin: 0 0 10px;
  font-size: 12px;
  color: var(--text, #2d2d2d);
}

.folder-move-summary-hint {
  color: var(--text-muted, #6b7280);
  font-style: italic;
}

.folder-copy-toast {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(32, 32, 32, 0.92);
  color: #fff;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 12px;
  z-index: 1100;
  pointer-events: none;
}

.folder-tree-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
  color: inherit;
  flex-shrink: 0;
}

.folder-tree-chevron:disabled {
  cursor: default;
  opacity: 0.5;
}

.folder-tree-chevron .material-icons-round {
  font-size: 18px;
}

.folder-tree-chevron-spacer {
  display: inline-block;
  width: 18px;
  flex-shrink: 0;
}

.folder-tree-icon {
  font-size: 16px;
  color: var(--primary);
  flex-shrink: 0;
}

.folder-tree-row.is-selected .folder-tree-icon {
  color: var(--primary);
}

.folder-tree-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.folder-tree-refresh {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  margin-left: auto;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  cursor: pointer;
  color: var(--primary, #0078d4);
  flex-shrink: 0;
}

.folder-tree-refresh:hover:not(:disabled) {
  background: var(--hover-bg, rgba(0, 0, 0, 0.06));
}

.folder-tree-refresh:disabled {
  cursor: default;
  opacity: 0.6;
}

.folder-tree-refresh .material-icons-round {
  font-size: 16px;
}

.folder-tree-refresh-icon--spinning {
  animation: folder-tree-refresh-spin 0.8s linear infinite;
}

@keyframes folder-tree-refresh-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/SharePointFolderPicker/FolderTree.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wDAAwD;EACxD,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".folder-tree {\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  background: #fff;\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 4px 0;\n  font-size: 13px;\n  outline: none;\n}\n\n.folder-tree--empty {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: center;\n  padding: 16px;\n  color: var(--text-muted, #8a8a8a);\n  font-size: 12px;\n}\n\n.folder-tree--empty .material-icons-round {\n  font-size: 16px;\n}\n\n.folder-tree-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-right: 8px;\n  cursor: pointer;\n  user-select: none;\n  outline: none;\n  border-radius: 4px;\n  margin: 1px 4px;\n}\n\n.folder-tree-row:hover {\n  background: var(--hover-bg, rgba(0, 0, 0, 0.04));\n}\n\n.folder-tree-row:focus-visible {\n  box-shadow: 0 0 0 2px var(--primary);\n}\n\n.folder-tree-row.is-selected {\n  background: var(--primary-soft, rgba(0, 120, 212, 0.12));\n  color: var(--primary);\n  font-weight: 500;\n}\n\n.folder-tree-row--root {\n  font-weight: 500;\n  border-bottom: 1px solid var(--border-light);\n  border-radius: 0;\n  margin: 0;\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.folder-tree-row--pending {\n  cursor: default;\n}\n\n.folder-tree-row--pending:hover {\n  background: transparent;\n}\n\n.folder-tree-pending-input {\n  flex: 1;\n  border: 1px solid var(--primary, #0078d4);\n  border-radius: 4px;\n  padding: 1px 6px;\n  font-size: 13px;\n  outline: none;\n  min-width: 0;\n}\n\n.folder-tree-pending-input:disabled {\n  opacity: 0.6;\n}\n\n.folder-tree-pending-error {\n  color: var(--error, #c4314b);\n  font-size: 11px;\n  padding: 2px 8px 4px;\n}\n\n.folder-tree-rename-wrap {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.folder-tree-rename-wrap .folder-tree-pending-error {\n  padding: 0;\n}\n\n.folder-context-menu {\n  position: fixed;\n  z-index: 1000;\n  background: #fff;\n  border: 1px solid var(--border-light);\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 4px 0;\n  min-width: 160px;\n}\n\n.folder-context-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 6px 12px;\n  background: transparent;\n  border: none;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n  color: inherit;\n}\n\n.folder-context-menu-item:hover:not(:disabled) {\n  background: var(--hover-bg, rgba(0, 0, 0, 0.05));\n}\n\n.folder-context-menu-item:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.folder-context-menu-item .material-icons-round {\n  font-size: 16px;\n  color: var(--primary, #0078d4);\n}\n\n.folder-context-menu-item--danger {\n  color: var(--error, #c4314b);\n}\n\n.folder-context-menu-item--danger .material-icons-round {\n  color: var(--error, #c4314b);\n}\n\n.folder-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1200;\n  padding: 16px;\n}\n\n.folder-confirm-dialog {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  padding: 16px;\n  max-width: 360px;\n  width: 100%;\n  font-size: 13px;\n}\n\n.folder-confirm-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.folder-confirm-icon {\n  font-size: 20px;\n  color: var(--error, #c4314b);\n}\n\n.folder-confirm-body {\n  margin: 0 0 12px;\n  line-height: 1.4;\n  color: var(--text, #2d2d2d);\n}\n\n.folder-confirm-error {\n  margin: 0 0 12px;\n  color: var(--error, #c4314b);\n  font-size: 12px;\n}\n\n.folder-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.folder-confirm-btn {\n  padding: 6px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--border-light);\n  background: #fff;\n  font-size: 13px;\n  cursor: pointer;\n  color: inherit;\n}\n\n.folder-confirm-btn:hover:not(:disabled) {\n  background: var(--hover-bg, rgba(0, 0, 0, 0.05));\n}\n\n.folder-confirm-btn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.folder-confirm-btn--danger {\n  background: var(--error, #c4314b);\n  border-color: var(--error, #c4314b);\n  color: #fff;\n}\n\n.folder-confirm-btn--danger:hover:not(:disabled) {\n  background: #a8273c;\n}\n\n.folder-confirm-btn--primary {\n  background: var(--primary, #0078d4);\n  border-color: var(--primary, #0078d4);\n  color: #fff;\n}\n\n.folder-confirm-btn--primary:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.folder-move-dialog {\n  max-width: 420px;\n}\n\n.folder-move-icon {\n  font-size: 20px;\n  color: var(--primary, #0078d4);\n}\n\n.folder-move-tree-wrap {\n  margin: 0 0 10px;\n}\n\n.folder-move-tree-wrap .folder-tree {\n  max-height: 220px;\n}\n\n.folder-move-summary {\n  margin: 0 0 10px;\n  font-size: 12px;\n  color: var(--text, #2d2d2d);\n}\n\n.folder-move-summary-hint {\n  color: var(--text-muted, #6b7280);\n  font-style: italic;\n}\n\n.folder-copy-toast {\n  position: fixed;\n  bottom: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(32, 32, 32, 0.92);\n  color: #fff;\n  padding: 6px 14px;\n  border-radius: 16px;\n  font-size: 12px;\n  z-index: 1100;\n  pointer-events: none;\n}\n\n.folder-tree-chevron {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  padding: 0;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  color: inherit;\n  flex-shrink: 0;\n}\n\n.folder-tree-chevron:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.folder-tree-chevron .material-icons-round {\n  font-size: 18px;\n}\n\n.folder-tree-chevron-spacer {\n  display: inline-block;\n  width: 18px;\n  flex-shrink: 0;\n}\n\n.folder-tree-icon {\n  font-size: 16px;\n  color: var(--primary);\n  flex-shrink: 0;\n}\n\n.folder-tree-row.is-selected .folder-tree-icon {\n  color: var(--primary);\n}\n\n.folder-tree-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n}\n\n.folder-tree-refresh {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  padding: 0;\n  margin-left: auto;\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--primary, #0078d4);\n  flex-shrink: 0;\n}\n\n.folder-tree-refresh:hover:not(:disabled) {\n  background: var(--hover-bg, rgba(0, 0, 0, 0.06));\n}\n\n.folder-tree-refresh:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n.folder-tree-refresh .material-icons-round {\n  font-size: 16px;\n}\n\n.folder-tree-refresh-icon--spinning {\n  animation: folder-tree-refresh-spin 0.8s linear infinite;\n}\n\n@keyframes folder-tree-refresh-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
